import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FAQ from '../components/FAQ';
import { useScrollReveal } from '../utils/useScrollReveal';

const FaqPage = () => {
  useScrollReveal();
  return (
    <div className="App">
      <Header />
      <div style={{ paddingTop: 80 }}>
        <FAQ />
      </div>
      <Footer />
    </div>
  );
};

export default FaqPage;
